import { Children, cloneElement } from 'react';

/**
 * Disables top-level child of the given element.
 *
 * NOTE: This is meant to be used as a util for disabling a child in combination with Tooltip, which expects a single child.
 *
 * @param children - The children to disable.
 * @returns The disabled child.
 */
export function disableChild(children) {
  const oneChild = Children.only(children);
  return /*#__PURE__*/cloneElement(oneChild, {
    disabled: true
  });
}